import React from 'react';
import { 
	func, 
	array
} from 'prop-types';
import CustomHighlight from './CustomHighlight';
import style from './style';

const Presenter = ({ hits,onReceiveSentinel,onClickCard }) => (
	<style.Wrapper>
		<style.SearchbarWrapper>
			<style.CustomInstantSearch />
		</style.SearchbarWrapper>
		<style.CardlistWrapper>
			{hits.map(hit =>{
				return <style.RecipeCard 
					onClickCard={()=>{onClickCard(hit.objectID);}}
					onClickTag={()=>{}}
					key={hit.objectID}
					recipe={{
						userName : <CustomHighlight attribute="userName" hit={hit} />,
						name : <CustomHighlight attribute="name" hit={hit} />,
						discription : <CustomHighlight attribute="discription" hit={hit} />,
						imageUrl : hit.imageUrl,
						tags : hit.tags,
						timeLimit : hit.timeLimit,
						thumbFrom : hit.thumbFrom,
						likeFrom : hit.likeFrom
					}}
				/>;
			}
		
			)}
			<div ref={onReceiveSentinel}></div>
		</style.CardlistWrapper>
	</style.Wrapper>
);

Presenter.propTypes = {
	hits : array.isRequired,
	onClickCard : func.isRequired,
	onReceiveSentinel : func.isRequired,
};


export default Presenter;